export const saveInstanceToStorage = (instance: string) => {
    try {
         localStorage.setItem('backend_instance', JSON.stringify(instance));
    } catch (error) {
        // eslint-disable-next-line no-console
        console.warn('Failed to save instance to localStorage:');
    }
};

export const getStoredInstance = (): string | null => {
    try {
        const storedInstance = localStorage.getItem('backend_instance');
        if (storedInstance) {
            const parsed = JSON.parse(storedInstance);
            return typeof parsed === 'string' ? parsed : parsed.api_base_url || '';
        }
    } catch (error) {
        return null;
    }
    return null;
};
